<core-popover #popover placement="bottom-start" [padding]="padding">
  <div class="inline-flex gap-xs" slot="anchor">
    <core-icon-button icon="thumb_up"
                      [filled]="feedback === 'good'"
                      btnStyle="ghost"
                      (triggered)="positiveFeedback(popover)"></core-icon-button>
    <core-icon-button class="hidden md:inline-block"
                      icon="thumb_down"
                      [filled]="feedback === 'bad'"
                      btnStyle="ghost"
                      (triggered)="openPopOver(popover)"></core-icon-button>
    <core-icon-button class="md:hidden"
                      icon="thumb_down"
                      [filled]="feedback === 'bad'"
                      btnStyle="ghost"
                      (triggered)="openModal()"></core-icon-button>
  </div>
  <app-feedback-popover slot="popover" [popover]="popover" (dismissed)="popover.hide()"
                        (feedbackSubmitted)="openPopOver(popover, $event)"></app-feedback-popover>
</core-popover>
